import { Box, IconButton, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const styles = {
  closeBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
};

export default function ExportTemplateDialog({ show, close, onExport }: any) {
  return (
    <Dialog
      open={show}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" fontWeight={"510"}>
        Export Form Elements
      </DialogTitle>
      <IconButton aria-label="close" onClick={close} sx={styles.closeBtn}>
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          color="rgba(0, 0, 0, 0.87)"
        >
          Exporting the form elements will allow you to take all configuration
          for this template, and import it for another template.
        </DialogContentText>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            backgroundColor: "#E5F6FD",
            px: 2,
            py: 1.5,
            mt: 2,
          }}
        >
          <InfoOutlinedIcon sx={{ color: "#0288D1" }} />
          <Typography fontSize={14} color="#014361" ml={1}>
            When exporting for testing, be sure you export from the production
            environment for the most up-to-date version. This will cause the
            least amount of broken connections when pushing changes to open
            orders.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={close}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onExport}>
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}
